"use strict";
// NPI check digit (SPEC §3.3, §14.2, Appendix A.2): the CMS NPI standard computes a Luhn check digit over
// the NPI prefixed with `80840` (the health-industry issuer code), so the full 15 digits must pass Luhn.
// Standard library only: the loaders, the configuration schemas and the web forms all call it.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidNpi = isValidNpi;
const NPI_PATTERN = /^\d{10}$/;
const NPI_LUHN_PREFIX = "80840";
function passesLuhn(digits) {
    let sum = 0;
    for (let i = 0; i < digits.length; i += 1) {
        const digit = Number(digits[digits.length - 1 - i]);
        const doubled = i % 2 === 1 ? digit * 2 : digit;
        sum += doubled > 9 ? doubled - 9 : doubled;
    }
    return sum % 10 === 0;
}
/** True when `npi` is 10 digits and its last digit is the Luhn check digit under the `80840` prefix. */
function isValidNpi(npi) {
    return NPI_PATTERN.test(npi) && passesLuhn(`${NPI_LUHN_PREFIX}${npi}`);
}
//# sourceMappingURL=npi.js.map